module.exports = __webpack_public_path__ + "media/assets/file-1801ba4d3700b960960e79f617d3d2fb0306dcc5db3c27ff83fd502b7140f7b8.svg";